(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cdl-category-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cdl-category-menu')) {
  customElements.define('cdl-category-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const categories = [...this.querySelectorAll('details')];
      const select = (selected) => {
        if (categories.some(item => item !== selected && item.contains(document.activeElement))) return;
        categories.forEach(item => { item.open = item === selected; });
      };
      categories.forEach(item => {
        const summary = item.querySelector('summary');
        summary.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') select(item);
        });
        summary.addEventListener('focus', () => select(item));
        summary.addEventListener('click', event => {
          event.preventDefault();
          select(item);
        });
      });
      this.querySelectorAll('.cdl-category-nav__single').forEach(link => {
        link.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') select(null);
        });
        link.addEventListener('focus', () => select(null));
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cdl-hand-tools-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cdl-hand-tools-menu')) {
  customElements.define('cdl-hand-tools-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const categories = [...this.querySelectorAll('details')];
      const select = (selected) => {
        if (categories.some(item => item !== selected && item.contains(document.activeElement))) return;
        categories.forEach(item => { item.open = item === selected; });
      };
      categories.forEach(item => {
        const summary = item.querySelector('summary');
        summary.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') select(item);
        });
        summary.addEventListener('focus', () => select(item));
        summary.addEventListener('click', event => {
          event.preventDefault();
          select(item);
        });
      });
      this.querySelectorAll('.cdl-hand-nav__single').forEach(link => {
        link.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') select(null);
        });
        link.addEventListener('focus', () => select(null));
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
